<template>
    <!-- 会员管理－补开卡页面 -->
    <div>
        <content-view>
            <div class="wrap-container-in">
                <a-form :form="form" class="ticket-one-form">
                    <a-form-item v-show="$route.name != 'addSmartWrist'" label="设备ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input placeholder="请输入" disabled v-decorator="['deviceId']"></a-input>
                    </a-form-item>
                    <a-form-item label="设备类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select placeholder="请选择" :disabled="isDisabled" v-decorator="['deviceType',{initialValue: 1},{rules: [{required: true, message: '请输入设备类型',}]}]">
                            <a-select-option :value="1">腕带</a-select-option>
                            <a-select-option :value="2">卡片</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="所属门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select placeholder="请选择" :disabled="isDisabled" v-decorator="['shopId',{rules: [{required: true, message: '请选择所属门店',}]}]">
                            <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="IC识别ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input placeholder="请输入" :disabled="isDisabled" v-decorator="['icRecogniseId',{rules: [{required: true, message: '请输入IC识别ID'}]}]"></a-input>
                    </a-form-item>
                    <a-form-item label="定位识别ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input placeholder="请输入" :disabled="isDisabled" v-decorator="['posiRecogniseId',{rules: [{required: true, message: '请输入定位识别ID'}]}]"></a-input>
                    </a-form-item>
                    <a-form-item label="人员属性" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select placeholder="请选择" :disabled="isDisabled" v-decorator="['peopleType',{rules: [{required: true, message: '请选择人员属性',}]}]">
                            <a-select-option :value="1">儿童</a-select-option>
                            <a-select-option :value="2">大人</a-select-option>
                            <a-select-option :value="3">工作人员</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="设备颜色" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select placeholder="请选择" :disabled="isDisabled" v-decorator="['deviceColor',{rules: [{required: true, message: '请选择设备颜色',}]}]">
                            <a-select-option value="1">黄色</a-select-option>
                            <a-select-option value="2">紫色</a-select-option>
                            <a-select-option value="3">红色</a-select-option>
                            <a-select-option value="4">蓝色</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="激活方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-radio-group :disabled="isDisabled" v-decorator="['activeStatus',{initialValue: 1}]">
                            <a-radio :value="1">需激活</a-radio>
                            <a-radio :value="0">无需激活</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input :disabled="isDisabled" placeholder="请输入" v-decorator="['remark']"></a-input>
                    </a-form-item>
                    <a-form-item class="text-center">
                        <a-button @click="$router.go(-1)">返回</a-button>
                        <a-button v-if="!isDisabled" type="primary" @click="handleSubmit">保存</a-button>
                    </a-form-item>
                </a-form>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import moment from 'moment';
    export default {
        name: 'addSmartWrist',
        components: {},
        props: {},
        data() {
            return {
                labelCol: {span: 8},
                wrapperCol: {span: 8},
                shopList: [],
                id: undefined,
                isDisabled: this.$route.name == 'detailSmartWrist'
            };
        },
        computed: {},
        methods: {
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    this.shopList = res;
                });
            },
            handleSubmit() {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        this.$api.wrist[this.id?'deviceEdit':'deviceAdd']
                        ({
                            body: Object.assign(values,{
                                id: this.id,
                                shopName: this.shopList.filter(item => item.id === values.shopId)[0].name
                            })
                        })
                        .then(res => {
                            this.$message.success('操作成功');
                            this.$router.go(-1)
                        });
                    }
                });
            },
            deviceDetial() {
                this.id = this.$route.query.id;
                if(!this.id) return;
                this.$api.wrist.deviceDetial({
                    params: {id: this.id}
                }).then(res => {
                    let valuesForm = {
                        activeStatus: res.activeStatus,
                        deviceColor: res.deviceColor,
                        deviceId: res.deviceId,
                        deviceType: res.deviceType,
                        icRecogniseId: res.icRecogniseId,
                        peopleType: res.peopleType,
                        posiRecogniseId: res.posiRecogniseId,
                        remark: res.remark,
                        shopId: String(res.shopId)
                    }
                    this.$nextTick(() => {
                        this.form.setFieldsValue(valuesForm);
                    })
                });
            }
        },
        created() {},
        mounted() {
            this.getShopList();
            this.deviceDetial()
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        }
    };
</script>
<style lang="scss">
</style>